export const validateDigitOnly = (value: string): boolean => {
  const digitRegex = /^\d*$/;
  return digitRegex.test(value);
};
